export default __webpack_public_path__ + "static/media/P204.1.ec1de705.mp3";